export default __webpack_public_path__ + "static/media/EM1960.34I-43235_-25850_0.9bb37092.jpg";